<template>
  <div class="registered">
    <div class="register-to-vote__text-block register-to-vote__text-block--info">
      <Icon
        class="register-to-vote__icon--info"
        icon-name="info"
        view-box="0 0 15 15"
      />

      <p>
        {{ $t("cac.app.currently_registered_to_vote") }}
        {{ voterInformation.stateName }}
      </p>
      <p>{{ $t("cac.app.is_this_you") }}</p>
    </div>

    <div class="name-badge">
      <span class="name-badge__title">{{ advocateName }}</span>
      <span>{{ advocateDetails.address }}</span>
    </div>

    <div class="d-flex flex-column align-items-center">
      <router-link
        :to="{name: routes.VOTER_INFORMATION}"
        class="btn btn--primary mb-3"
      >
        {{ $t("cac.app.yes_show_voter_information") }}
      </router-link>
      <a
        href="#"
        class="register-to-vote__link--that-isnt-me"
        @click.prevent="updateRegistrationStatus(false)"
      >
        {{ $t("cac.app.no_that_isnt_me") }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { startCase as _startCase } from "lodash";
import STATE from "Constants/campaign/civicactioncenter/state";
import Routes from "Constants/campaign/civicactioncenter/routeNames";
import Icon from "StyleguideComponents/Icon.vue";

const voterInformationContext = `${STATE.SCOPE_CAC}/${STATE.VOTER_INFORMATION}`;

export default {
  name: "Registered",
  components: {
    Icon
  },
  props: {
    resetCookieUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      routes: Routes
    };
  },
  computed: {
    ...mapState(STATE.SCOPE_CAC, {
      voterInformation: STATE.VOTER_INFORMATION
    }),
    advocateDetails() {
      return {
        firstName: this.voterInformation.registrationStatus.firstName,
        lastName: this.voterInformation.registrationStatus.lastName,
        address: this.voterInformation.registrationStatus.address,
        stateName: this.voterInformation.stateName
      };
    },
    advocateName() {
      const { firstName, lastName } = this.advocateDetails;
      const advocateName = `${firstName} ${lastName}`;
      return _startCase(advocateName);
    }
  },
  methods: {
    ...mapActions({
      setVoterInformation: voterInformationContext
    }),
    updateRegistrationStatus(status) {
      const voterInformation = { ...this.voterInformation };

      voterInformation.registrationStatus.registered = !!status;

      this.setVoterInformation(voterInformation);
    }
  }
};
</script>
